<template>
  <div>
    <base-material-stats-card
      v-if="!isLoading"
      :color="color"
      :icon="icon"
      :title="title"
      :value="valueString"
      :sub-icon="subText ? 'mdi-comment-question-outline' : 'mdi-emoticon-excited-outline'"
      :sub-text="subText"
      :sub-icon-color="subText ? undefined : 'white'"
      :small-value="smallValue"
      :small-height="smallHeight"
    />
    <base-material-stats-card
      v-else
      :color="color"
      :icon="icon"
      :title="title"
      :small-height="smallHeight"
    >
      <!-- Affichage de l'erreur -->
      <card-alert
        v-if="hasError"
        :msg="errorMsg"
      />
      <!-- Affichage du chargement -->
      <v-row
        v-else
        justify="center"
      >
        <circle10 />
      </v-row>
    </base-material-stats-card>
  </div>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import CardAlert from '../../alerts/CardAlert.vue'
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'StatsTemplate',

    /* Sous-composants utilisés par ce composant */
    components: {
      CardAlert,
      Circle10,
    },

    /* Paramètres */
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: 'Erreur',
      },
      icon: {
        type: String,
        default: 'mdi-bell',
      },
      title: {
        type: String,
        default: '',
      },
      value: {
        type: Number,
        default: undefined,
      },
      smallValue: {
        type: String,
        default: undefined,
      },
      subText: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
      smallHeight: {
        type: Boolean,
        default: undefined,
      },
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      valueString: function () {
        if (
          this.value === null ||
          this.value === undefined ||
          this.value === ''
        ) {
          return 'Aucune donnée.'
        } else {
          return this.value.toString(10)
        }
      },
    },
  }
</script>
